/** No-link marketplace members (cmWithNoLink). */
export const isNoLinkMember = (user) =>
  user?.role === "memberNoLink" || Boolean(user?.memberNoLink);

export const isMemberSubscribed = (user) =>
  Boolean(user?.memberCommunities?.[0]?.subscribed);

/**
 * Community label for CM UI.
 * - Linked members: always show community name (even if unsubscribed).
 * - NoLink + unsubscribed: "N/A" (do not keep showing last community).
 * - NoLink + subscribed: show community name.
 */
export const getMemberCommunityDisplayName = (
  user,
  { fallback = "", whenUnsubscribedNoLink = "N/A" } = {}
) => {
  if (isNoLinkMember(user) && !isMemberSubscribed(user)) {
    return whenUnsubscribedNoLink;
  }
  const community = user?.memberCommunities?.[0]?.community;
  return community?.disPlayName || community?.name || fallback;
};
